<template>
	<div class="wuxing-page">
		<!-- <div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div> -->
		<div class="logo">
			<img :src="logo" alt="五行逐梦卡" />
		</div>

		<div class="content" :class="{'confirmClaim': is_claim_freeCard === 1,'bindCardContent': is_bind_card === 1}">
			<img v-if="is_bind_card === 1" :src="bindCardContentBgImg" class="contentBgImg" />
			<img v-else-if="is_claim_freeCard === 0" :src="contentBgImg" class="contentBgImg" />
			<img v-else :src="confirmContentBgImg" class="contentBgImg" />
			<div v-if="is_bind_card === 1" class="bank_card"><span>{{ formattedBankCard }}</span></div>
			<!-- 输入框区域 -->
			<div class="input-wrapper">
				<!-- 如果已绑定银行卡，显示银行卡信息 -->
				<template v-if="is_bind_card === 1">
					<!-- 银行卡号输入框 -->
					<div class="input-group disabled-group">
						<span class="input-label">
							<span class="required-star">*</span>
							银行卡号：
						</span>
						<input v-model="bankCardData.bank_card" type="text" class="input-field" required
							placeholder="银行卡号" disabled readonly>
					</div>

					<!-- 姓名输入框 -->
					<div class="input-group disabled-group">
						<span class="input-label">
							<span class="required-star">*</span>
							姓&emsp;&emsp;名：
						</span>
						<input v-model="bankCardData.bank_card_name" type="text" class="input-field" required
							placeholder="持卡人姓名" disabled readonly>
					</div>

					<!-- 身份证号输入框 -->
					<div class="input-group disabled-group">
						<span class="input-label">
							<span class="required-star">*</span>
							身份证号：
						</span>
						<input v-model="bankCardData.id_card" type="text" class="input-field" required
							placeholder="身份证号码" disabled readonly>
					</div>
				</template>

				<!-- 如果未绑定银行卡，显示地址信息 -->
				<template v-else>
					<!-- 姓名输入框 -->
					<div class="input-group" :class="{ 'disabled-group': hasAddress }">
						<span class="input-label">
							<span class="required-star">*</span>
							姓&emsp;&emsp;名：
						</span>
						<input v-model="formData.name" type="text" class="input-field" required placeholder="请输入您的姓名"
							:disabled="hasAddress" :readonly="hasAddress">
					</div>

					<!-- 手机号码输入框 -->
					<div class="input-group" :class="{ 'disabled-group': hasAddress }">
						<span class="input-label">
							<span class="required-star">*</span>
							手机号码：
						</span>
						<input v-model="formData.phone" type="tel" class="input-field" required placeholder="请输入您的手机号码"
							:disabled="hasAddress" :readonly="hasAddress">
					</div>

					<!-- 所在地区选择框 -->
					<div class="input-group area-group" :class="{ 'disabled-group': hasAddress }"
						@click="!hasAddress && (showAreaPopup = true)">
						<span class="input-label">
							<span class="required-star">*</span>
							所在地区：
						</span>
						<div class="input-field area-field" :class="{ 'placeholder': !formData.areaText }">
							{{ formData.areaText || '请选择您所在地区' }}
						</div>
						<van-icon name="arrow" class="arrow-icon" />
					</div>

					<!-- 详细地址输入框 -->
					<div class="input-group textarea-group" :class="{ 'disabled-group': hasAddress }">
						<span class="input-label">
							<span class="required-star">*</span>
							详细地址：
						</span>
						<textarea v-model="formData.detailAddress" class="input-field textarea-field" required
							placeholder="请输入您的详细地址" @input="autoResizeTextarea" rows="1" ref="detailAddressTextarea"
							:disabled="hasAddress" :readonly="hasAddress">
									</textarea>
					</div>
				</template>
			</div>

			<!-- 如果已绑定银行卡，显示提示和修改按钮 -->
			<div v-if="is_bind_card === 1" class="bind-hint-text">
				您的"逐梦卡"绑定成功
			</div>

			<!-- 信息修改/设置密码按钮（仅当已绑定银行卡时显示） -->
			<div v-if="is_bind_card === 1" class="modify-btn" @click="handleModifyOrSetPassword">
				{{ modifyBtnText }}
			</div>

			<!-- 免费领卡按钮（仅当未绑定银行卡且未领取卡片时显示） -->
			<img v-if="is_claim_freeCard === 0 && is_bind_card !== 1" :src="freeCardImg" class="freeCardImg submit-img"
				alt="免费领卡" @click="handleSubmit" />
		</div>

		<!-- <div v-if="is_claim_freeCard === 1" class="tip">
			<img :src="tipImg" alt="逐梦卡正在制卡中" />
		</div> -->
		<div v-if="is_claim_freeCard === 1" class="tip">
			<img :src="tipImg" alt="逐梦卡邮寄完成" />
		</div>

		<!-- 绑定银行卡按钮（仅当已领取卡片但未绑定银行卡时显示） -->
		<div v-if="is_claim_freeCard === 1 && is_bind_card !== 1" class="bindCard" @click="goBindCard">
			<img :src="bindCardImg" alt="逐梦卡绑定" />
		</div>
		<!-- 签约协议按钮（仅当已领取卡片和已绑定银行卡但未签约协议时显示） -->
		<div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement != 1" class="bindCard"
			@click="handleGoSigningAgreement">
			<img :src="signingAgreementImg" alt="签约协议" />
		</div>
		<!-- 协议生效（仅当已领取卡片和已绑定银行卡和已签约协议时显示） -->
		<!-- <div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement === 1"
			class="bindCard progress-state">
			<div class="progress-bg">
				<img :src="progressBgImg" alt="协议生效" class="progress-bg-img" />
				<img :src="currentProgressImg" alt="进度条" class="progress-bar-img" />
			</div>
		</div> -->
		<!-- 协议完成（仅当已领取卡片和已绑定银行卡和协议完成时显示） -->
		<div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement === 1"
			class="bindCard first-bind-card">
			<img :src="agreementCompleted" alt="协议完成" />
		</div>
		<!-- 协议完成（仅当已领取卡片和已绑定银行卡和协议完成时和未开通额度时显示） -->
		<div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement === 1 && is_open_credit !== 1"
			class="bindCard" @click="$router.push('/selectLimit')">
			<img :src="selectLimit" alt="前往开通额度" />
		</div>
		<!-- 协议完成（仅当已领取卡片和已绑定银行卡和协议完成时和已开通额度时显示） -->
		<div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement === 1 && is_open_credit === 1"
			class="bindCard" @click="$router.push('/selectLimit')">
			<img :src="openCreditLimit" alt="已开通额度" />
		</div>

		<div v-if="is_claim_freeCard === 1 && is_bind_card === 1 && is_signing_agreement === 1 && is_open_credit === 1"
			class="second-content">
			<div class="first-line">
				<div class="name">
					Hi，{{ user_name }}
				</div>
				<div class="icon">
					<div class="icon-content" v-for="(item, idx) in firstItems" :key="'r' + idx">
						<img class="icon-image" :src="getIconImage(item.file)" :alt="item.alt" @click="onAction" />
					</div>
				</div>
			</div>
			<div class="second-line">
				<div class="icon-content" v-for="(item, idx) in secondItems" :key="'r' + idx">
					<img class="icon-image" :src="getIconImage(item.file)" :alt="item.alt" @click="onAction" />
				</div>
			</div>
			<div class="third-line">
				<span class="wealth-title">五行财富</span>
				<div class="balance-content">
					<div class="account-balance">
						<img :src="secondAccountBalanceImg" alt="账户余额" class="balance-bg" />
						<div class="balance-text">
							<span class="balance-label">我的账户余额</span>
							<span class="balance-value">￥{{ formatAmount(remainingMoney) }}</span>
						</div>
					</div>
					<div class="card-balance">
						<img :src="secondCardBalanceImg" alt="逐梦卡余额" class="balance-bg" />
						<div class="balance-text">
							<span class="balance-label">逐梦卡余额</span>
							<span class="balance-value">￥{{ formatAmount(card_money) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="fourth-line">
				<template v-if="is_appointment_withdrawal != 1">
					<img :src="secondAppointmentText1Img" alt="" />
					<img :src="secondAppointmentButton1Img" alt="立即预约"
						@click="$router.push('/appointmentWithdrawal')" />
				</template>
				<!-- <template v-else>
					<img :src="secondAppointmentText2Img" alt="" />
					<img :src="secondAppointmentButton2Img" alt="查看预约进度" @click="$router.push('/appointmentInfo')" />
				</template> -->
				<template v-else>
					<img :src="secondAppointmentText3Img" alt="" />
					<img :src="secondAppointmentButton3Img" alt="点击查看详情" @click="$router.push('/appointmentFailed')" />
				</template>
				<template v-if="is_claim_vouchers == 1">
					<img :src="secondAppointmentText4Img" alt="" />
					<img :src="secondAppointmentButton4Img" alt="上传资金凭证" @click="$router.push('/uploadVoucher')" />
				</template>
			</div>
		</div>

		<!-- 地区选择弹出层 -->
		<van-popup v-model="showAreaPopup" position="bottom" round :style="{ height: '40%' }">
			<van-area :area-list="areaList" :value="formData.areaCode" @confirm="onAreaConfirm"
				@cancel="showAreaPopup = false" title="请选择所在地区" />
		</van-popup>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import logoImg from '@/assets/withdrawBankCard/logo.png';
	import contentBgImg from '@/assets/withdrawBankCard/content_bg.png';
	import confirmContentBgImg from '@/assets/withdrawBankCard/confirm_content_bg.png';
	import bindCardContentBgImg from '@/assets/withdrawBankCard/bindcard_content_bg.png';
	import freeCardImg from '@/assets/withdrawBankCard/free_card.png';
	// import tipImg from '@/assets/withdrawBankCard/tip.png';
	import tipImg from '@/assets/withdrawBankCard/tip2.png';
	import bindCardImg from '@/assets/withdrawBankCard/bindCard.png';
	import signingAgreementImg from '@/assets/withdrawBankCard/signing_agreement.png';
	// import progressBgImg from '@/assets/withdrawBankCard/progress_bg.png';
	// import progressImg1 from '@/assets/withdrawBankCard/progress1.png';
	// import progressImg2 from '@/assets/withdrawBankCard/progress2.png';
	// import progressImg3 from '@/assets/withdrawBankCard/progress3.png';
	// import progressImg4 from '@/assets/withdrawBankCard/progress4.png';
	// import progressImg5 from '@/assets/withdrawBankCard/progress5.png';
	// import progressImg6 from '@/assets/withdrawBankCard/progress6.png';
	// import progressImg7 from '@/assets/withdrawBankCard/progress7.png';
	import agreementCompleted from '@/assets/withdrawBankCard/agreement_completed.png';
	import selectLimit from '@/assets/withdrawBankCard/select_limit.png';
	import openCreditLimit from '@/assets/withdrawBankCard/open_credit_limit.png';
	// import secondBgImg from '@/assets/withdrawBankCard/second_bg.png';
	// import secondTopBgImg from '@/assets/withdrawBankCard/second_top_bg.png';
	import secondAccountBalanceImg from '@/assets/withdrawBankCard/second_account_balance.png';
	import secondCardBalanceImg from '@/assets/withdrawBankCard/second_card_balance.png';
	import secondAppointmentText1Img from '@/assets/withdrawBankCard/second_appointment_text1.png';
	import secondAppointmentText2Img from '@/assets/withdrawBankCard/second_appointment_text2.png';
	import secondAppointmentText3Img from '@/assets/withdrawBankCard/second_appointment_text3.jpg';
	import secondAppointmentText4Img from '@/assets/withdrawBankCard/second_appointment_text4.png';
	import secondAppointmentButton1Img from '@/assets/withdrawBankCard/second_appointment_button1.png';
	import secondAppointmentButton2Img from '@/assets/withdrawBankCard/second_appointment_button2.png';
	import secondAppointmentButton3Img from '@/assets/withdrawBankCard/second_appointment_button3.png';
	import secondAppointmentButton4Img from '@/assets/withdrawBankCard/second_appointment_button4.png';
	import {
		Popup,
		Area,
		Icon,
		Dialog
	} from 'vant';
	import {
		areaList
	} from '@vant/area-data';

	export default {
		name: 'WithdrawBankCard',
		components: {
			[Popup.name]: Popup,
			[Area.name]: Area,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog
		},
		data() {
			return {
				logo: logoImg,
				contentBgImg: contentBgImg,
				confirmContentBgImg: confirmContentBgImg,
				bindCardContentBgImg: bindCardContentBgImg,
				freeCardImg: freeCardImg,
				tipImg: tipImg,
				bindCardImg: bindCardImg,
				signingAgreementImg: signingAgreementImg,
				// progressBgImg: progressBgImg,
				// progressImg1: progressImg1,
				// progressImg2: progressImg2,
				// progressImg3: progressImg3,
				// progressImg4: progressImg4,
				// progressImg5: progressImg5,
				// progressImg6: progressImg6,
				// progressImg7: progressImg7,
				agreementCompleted: agreementCompleted,
				selectLimit: selectLimit,
				openCreditLimit: openCreditLimit,
				// secondBgImg: secondBgImg,
				// secondTopBgImg: secondTopBgImg,
				secondAccountBalanceImg: secondAccountBalanceImg,
				secondCardBalanceImg: secondCardBalanceImg,
				secondAppointmentText1Img: secondAppointmentText1Img,
				secondAppointmentText2Img: secondAppointmentText2Img,
				secondAppointmentText3Img: secondAppointmentText3Img,
				secondAppointmentText4Img: secondAppointmentText4Img,
				secondAppointmentButton1Img: secondAppointmentButton1Img,
				secondAppointmentButton2Img: secondAppointmentButton2Img,
				secondAppointmentButton3Img: secondAppointmentButton3Img,
				secondAppointmentButton4Img: secondAppointmentButton4Img,
				user_name: null,
				money: 0,
				card_money: 0,
				is_account_verification: 0,
				is_claim_freeCard: 0,
				is_bind_card: 0, // 是否绑定逐梦卡
				is_signing_agreement: 0, // 是否签约协议
				is_open_credit: 0, // 是否开通额度
				is_appointment_withdrawal: 0, // 是否预约取款
				is_claim_vouchers: 0, // 是否领取凭证
				has_password: 0, // 是否设置了密码
				loading: false,
				error: null,
				formData: {
					phone: '',
					name: '',
					areaCode: '', // 地区编码
					areaText: '', // 地区显示文本
					detailAddress: '', // 详细地址
				},
				bankCardData: {
					bank_card: '',
					bank_card_name: '',
					id_card: '',
				},
				showAreaPopup: false,
				areaList: areaList,
				// 验证状态
				validationErrors: {
					name: false,
					phone: false,
					areaText: false,
					detailAddress: false
				},
				// 是否有地址的标志
				hasAddress: false,
				verificationTimer: null,
				rechargeInfo: {
					currentDay: 1, // 当前天数（1-7）
				},
				firstItems: [{
						file: '我的账户.png',
						alt: '我的账户'
					},
					{
						file: '收支明细.png',
						alt: '收支明细'
					},
					{
						file: '个人养老金.png',
						alt: '个人养老金'
					},
					{
						file: '支付.png',
						alt: '支付'
					},
				],
				secondItems: [{
						file: '存款.png',
						alt: '存款'
					},
					{
						file: '转账汇款.png',
						alt: '转账汇款'
					},
					{
						file: '生活缴费.png',
						alt: '生活缴费'
					},
					{
						file: '资产.png',
						alt: '资产'
					},
					{
						file: '数字货币.png',
						alt: '数字货币'
					},
					{
						file: '五行管家.png',
						alt: '五行管家'
					},
					{
						file: '微信.png',
						alt: '微信'
					},
					{
						file: '支付宝.png',
						alt: '支付宝'
					},
				],
			}
		},
		computed: {
			formattedBankCard() {
				// 先移除所有空格，然后每4位添加一个空格
				const cardNo = this.bankCardData.bank_card.replace(/\s/g, '');
				return cardNo.replace(/(\d{4})(?=\d)/g, '$1  ');
			},
			modifyBtnText() {
				return this.has_password === 1 ? '信息修改' : '设置密码';
			},
			// 计算剩余可提现金额：money - cardMoney，结果为负数则为0
			remainingMoney() {
				const moneyNum = parseFloat(this.money) || 0;
				const cardMoneyNum = parseFloat(this.card_money) || 0;
				const result = moneyNum - cardMoneyNum;
				return result < 0 ? 0 : result;
			}
			// 根据当前天数计算对应的进度条图片
			// currentProgressImg() {
			// 	const day = this.rechargeInfo.currentDay;
			// 	if (day >= 7) return this.progressImg7;
			// 	if (day >= 6) return this.progressImg6;
			// 	if (day >= 5) return this.progressImg5;
			// 	if (day >= 4) return this.progressImg4;
			// 	if (day >= 3) return this.progressImg3;
			// 	if (day >= 2) return this.progressImg2;
			// 	return this.progressImg1; // 默认第一天
			// }
		},
		created() {
			this.$parent.footer('withdrawBankCard');
		},
		mounted() {
			Fetch("/user/get_receipt_data")
				.then(res => {
					if (res.code === 1) {
						this.card_money = res.data.amount;
					} else {
						// this.$toast(res.msg || '获取回单数据失败');
					}
				}).catch(err => {
					console.error(err);
				});
			Fetch("/user/info")
				.then((r) => {
					this.is_account_verification = r.data.is_account_verification;
					this.is_claim_freeCard = r.data.is_claim_freeCard;
					this.is_bind_card = r.data.is_bind_card;
					this.is_signing_agreement = r.data.is_signing_agreement;
					this.is_open_credit = r.data.is_open_credit;
					this.is_appointment_withdrawal = r.data.is_appointment_withdrawal;
					this.is_claim_vouchers = r.data.is_claim_vouchers;
					this.user_name = r.data.name;
					this.money = r.data.money;
					// 如果已绑定银行卡，加载银行卡信息
					if (this.is_bind_card === 1) {
						this.loadBankCardInfo();
					}
					// 如果已签约协议，加载签约时间信息
					// if (this.is_signing_agreement === 1) {
					// 	this.loadSigningDateInfo();
					// }
				}).catch(e => {
					console.error('Fetch /user/info failed', e);
				});
			this.loadAddressInfo();
		},
		beforeDestroy() {
			// 组件销毁时清除定时器
			if (this.verificationTimer) {
				clearTimeout(this.verificationTimer);
				this.verificationTimer = null;
			}
		},
		methods: {
			getIconImage(file) {
				try {
					return require(`@/assets/icon/withdrawBankCard/${file}`)
				} catch (e) {
					console.warn('image not found:', file, e)
					return ''
				}
			},
			// 格式化金额显示，添加千分位分隔符
			formatAmount(amount) {
				// 确保金额是数字类型
				const num = parseFloat(amount);
				if (isNaN(num)) {
					return '0.00';
				}

				// 保留两位小数并添加千分位分隔符
				return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			onAction() {
				this.$toast({
					message: '请预约线下取款激活功能使用',
					duration: 3000,
				});
			},
			goBindCard() {
				this.$router.push('/withdrawBindCard');
			},
			goSigningAgreement() {
				this.$router.push('/signingAgreement');
			},

			// 处理签约协议点击
			handleGoSigningAgreement() {
				// 检查是否设置了密码
				if (this.has_password !== 1) {
					Dialog.confirm({
							title: '温馨提示',
							message: '请先设置密码',
							showCancelButton: true,
							confirmButtonText: '立即设置',
							cancelButtonText: '取消',
							confirmButtonColor: '#1989fa'
						})
						.then(() => {
							// 确认按钮点击事件
							this.$router.push('/withdrawBindCard');
						})
						.catch(() => {

						});

					return;
				}

				// 如果已设置密码，直接跳转
				this.goSigningAgreement();
			},

			// 处理修改/设置密码按钮点击
			handleModifyOrSetPassword() {
				this.goBindCard();
			},

			// 加载银行卡信息
			loadBankCardInfo() {
				Fetch('/user/check_bank_card').then((r) => {
					if (r.code === 1 && r.data) {
						this.bankCardData = {
							bank_card: r.data.bank_card || '',
							bank_card_name: r.data.bank_card_name || '',
							id_card: r.data.id_card || '',
						};
						this.has_password = r.data.has_password || 0;
					}
				}).catch(() => {
					console.log('加载银行卡信息失败');
				});
			},

			// 加载签约时间信息
			// loadSigningDateInfo() {
			// 	Fetch('/user/get_signing_date').then((r) => {
			// 		if (r.code === 1 || r.code === 0) { // 无论是否有记录都处理
			// 			if (r.data && r.data.current_day) {
			// 				this.rechargeInfo.currentDay = r.data.current_day;
			// 			} else {
			// 				// 没有数据时默认第一天
			// 				this.rechargeInfo.currentDay = 1;
			// 			}
			// 		}
			// 	}).catch((err) => {
			// 		console.log('加载签约时间失败', err);
			// 		this.rechargeInfo.currentDay = 1;
			// 	});
			// },

			// 地区选择确认
			onAreaConfirm(selectedValues) {
				if (this.hasAddress) return; // 如果有地址，不能选择

				// selectedValues 是选中的地区对象数组
				if (selectedValues && selectedValues.length > 0) {
					// 拼接地区文本
					const areaText = selectedValues.map(area => area.name).join(' ');
					// 获取地区编码（通常是最后一个选中的地区的编码）
					const areaCode = selectedValues[selectedValues.length - 1].code;

					this.formData.areaText = areaText;
					this.formData.areaCode = areaCode;
					// 清除地区验证错误
					this.validationErrors.areaText = false;
				}
				this.showAreaPopup = false;
			},

			// 自动调整textarea高度
			autoResizeTextarea(event) {
				if (this.hasAddress) return; // 如果有地址，不能编辑

				const textarea = event.target;
				textarea.style.height = 'auto';
				textarea.style.height = textarea.scrollHeight + 'px';
				// 清除详细地址验证错误
				if (this.formData.detailAddress.trim()) {
					this.validationErrors.detailAddress = false;
				}
			},

			// 表单验证
			validateForm() {
				// 重置验证状态
				this.validationErrors = {
					name: false,
					phone: false,
					areaText: false,
					detailAddress: false
				};

				// 表单验证
				let isValid = true;

				if (!this.formData.name || !this.formData.name.trim()) {
					this.validationErrors.name = true;
					this.$toast({
						message: '请输入收件人姓名',
					});
					isValid = false;
				}

				if (!this.formData.phone || !this.formData.phone.trim()) {
					this.validationErrors.phone = true;
					this.$toast({
						message: '请输入联系电话',
					});
					isValid = false;
				}

				if (!this.formData.areaText) {
					this.validationErrors.areaText = true;
					this.$toast({
						message: '请选择所在地区',
					});
					isValid = false;
				}

				if (!this.formData.detailAddress || !this.formData.detailAddress.trim()) {
					this.validationErrors.detailAddress = true;
					this.$toast({
						message: '请输入详细地址',
					});
					isValid = false;
				}

				return isValid;
			},

			// 提交地址信息
			submitAddress() {
				// 构建完整的地址信息
				const fullAddress = {
					name: this.formData.name,
					phone: this.formData.phone,
					address: this.formData.areaText + ' ' + this.formData.detailAddress,
					areaCode: this.formData.areaCode,
				};

				return Fetch('/user/address_add', fullAddress).then(res => {
					if (res.code === 1) {
						this.hasAddress = true; // 设置已有地址标志
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						return true;
					} else {
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						return false;
					}
				}).catch(err => {
					this.error = err;
					this.$toast({
						message: '地址保存失败，请重试',
					});
					return false;
				});
			},

			// 更新freeCard字段
			updateFreeCard() {
				return Fetch('/user/free_card_update').then(res => {
					if (res.code === 1) {
						this.is_claim_freeCard = 1;
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						return true;
					} else {
						this.$toast({
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
						return false;
					}
				}).catch(err => {
					this.error = err;
					this.$toast({
						message: '操作失败，请重试',
					});
					return false;
				});
			},

			// 跳转到验证页面的方法
			jumpToVerification() {
				// 清除定时器，防止重复跳转
				if (this.verificationTimer) {
					clearTimeout(this.verificationTimer);
					this.verificationTimer = null;
				}

				// 关闭弹窗
				Dialog.close();

				// 跳转到验证页面
				this.$router.push('/verification');
			},

			// 表单提交
			async handleSubmit() {
				// is_account_verification为0时，先弹出弹窗提示，3秒后跳转到verification组件
				if (this.is_account_verification === 0) {
					// 显示弹窗提示
					Dialog.alert({
						title: '温馨提示',
						message: '请先完成身份验证，即可免费领取五行逐梦卡',
						showCancelButton: false,
						confirmButtonText: '确定',
						confirmButtonColor: '#1989fa',
						// 添加确认按钮点击事件
						onConfirm: () => {
							this.jumpToVerification();
						}
					});

					// 设置3秒后自动跳转
					this.verificationTimer = setTimeout(() => {
						this.jumpToVerification();
					}, 3000);

					return;
				}

				// is_account_verification为1时
				if (this.is_account_verification === 1) {
					// 验证表单
					if (!this.validateForm()) {
						return;
					}

					this.loading = true;

					try {
						// 已有地址，直接更新freeCard
						if (this.hasAddress) {
							const updateResult = await this.updateFreeCard();
							if (updateResult) {
								// 更新成功，可以添加其他逻辑
							}
						}
						// 没有地址，先保存地址再更新freeCard
						else {
							// 先保存地址
							const addressResult = await this.submitAddress();
							if (addressResult) {
								// 地址保存成功，更新freeCard
								const updateResult = await this.updateFreeCard();
								if (updateResult) {
									// 更新成功，可以添加其他逻辑
								}
							}
						}
					} catch (error) {
						console.error('操作失败:', error);
					} finally {
						this.loading = false;
					}
				}
			},

			// 加载已有地址信息
			loadAddressInfo() {
				Fetch('/user/address_get').then((r) => {
					if (r.code === 1 && r.data) {
						// 有地址数据，设置已有地址标志
						this.hasAddress = true;
						// 填充表单
						this.formData = {
							...this.formData,
							...r.data
						};
						// 如果后端返回的地址是一个完整字符串，需要拆分处理
						if (r.data.address) {
							this.splitAddress(r.data.address);
						}
					} else {
						// 没有地址数据
						this.hasAddress = false;
					}
				}).catch(() => {
					this.hasAddress = false;
				});
			},

			// 拆分地址字符串为地区地址和详细地址
			splitAddress(fullAddress) {
				if (!fullAddress) return;

				// 按空格分割地址字符串
				const parts = fullAddress.split(' ');

				if (parts.length >= 3) {
					// 前三个部分作为省、市、区
					const province = parts[0] || '';
					const city = parts[1] || '';
					const district = parts[2] || '';

					// 拼接省市区作为地区地址
					this.formData.areaText = [province, city, district].filter(Boolean).join(' ');

					// 剩余部分作为详细地址
					this.formData.detailAddress = parts.slice(3).join(' ');
				} else if (parts.length === 2) {
					// 只有两个部分的情况（如直辖市）
					const province = parts[0] || '';
					const city = parts[1] || '';

					this.formData.areaText = [province, city].filter(Boolean).join(' ');
					this.formData.detailAddress = '';
				} else {
					// 只有一个部分或格式不正确
					this.formData.areaText = fullAddress;
					this.formData.detailAddress = '';
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.wuxing-page {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		background-image: url('../../assets/withdrawBankCard/bg.png');
		background-size: cover;
		background-position: center;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #333;
		position: relative;
		overflow: auto;
		padding-bottom: 50px;
	}

	.header-bar {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 4.26667vw;
		padding-bottom: 0;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 5vw;
	}

	.logo img {
		height: auto;
		width: 8rem;
		object-fit: contain;
		display: block;
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;
		margin-bottom: 5vw;
	}

	.contentBgImg {
		width: 90%;
		height: auto;
		object-fit: contain;
		display: block;
	}

	.bank_card {
		color: #fff;
		font-size: 24px;
		font-weight: bold;
		line-height: 1.4;
		white-space: pre;
		position: absolute;
		top: 20%;
	}

	/* 输入框区域样式 */
	.input-wrapper {
		width: 80%;
		position: absolute;
		bottom: 8%;
	}

	.confirmClaim .input-wrapper {
		bottom: 20%;
	}

	.bindCardContent .input-wrapper {
		bottom: 30%;
	}

	.input-group {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		padding: 10px;
		border-bottom: 1px solid #ebedf0;
		position: relative;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.95);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

		&:last-child {
			border-bottom: none;
		}

		/* 禁用状态样式 */
		&.disabled-group {
			background: rgba(248, 248, 248, 0.9);
			border-color: #e0e0e0;

			.input-label {
				color: #999;
			}

			.required-star {
				color: #ccc;
			}

			.input-field {
				color: #999;
				background: transparent;
				cursor: not-allowed;

				&::placeholder {
					color: #ccc;
				}
			}

			.area-field {
				color: #999;
				cursor: not-allowed;
			}

			.arrow-icon {
				color: #ccc;
			}
		}

		/* 验证错误样式 */
		&.error {
			border-bottom-color: #ee0a24;

			.input-label {
				color: #ee0a24;
			}

			.input-field {
				color: #ee0a24;

				&::placeholder {
					color: #ee0a24;
				}
			}

			.area-field {
				color: #ee0a24;
			}

			.arrow-icon {
				color: #ee0a24;
			}
		}
	}

	.input-label {
		font-size: 14px;
		color: #333;
		font-weight: 500;
		text-align: left;
		position: relative;
		display: flex;
		align-items: center;
	}

	.required-star {
		color: #ee0a24;
		font-size: 14px;
		margin: 0 5px;
		line-height: 1;
	}

	.input-field {
		flex: 1;
		border: none;
		outline: none;
		font-size: 14px;
		background: transparent;
		color: #333;
		padding: 0;

		&::placeholder {
			color: #969799;
		}

		/* 验证错误时的placeholder颜色 */
		&:invalid {
			border-color: #ee0a24;
		}

		/* 禁用状态 */
		&:disabled {
			background: transparent;
			color: #999;
			cursor: not-allowed;
		}

		&:read-only {
			background: transparent;
			color: #999;
			cursor: not-allowed;
		}
	}

	.area-field {
		color: #333;
		cursor: pointer;
		text-align: left;

		&.placeholder {
			color: #969799;
		}
	}

	.arrow-icon {
		font-size: 16px;
		color: #969799;
		margin-left: 8px;
	}

	.textarea-group {
		// align-items: flex-start;
	}

	.textarea-field {
		resize: none;
		overflow-y: auto;
		overflow-x: hidden;
		min-height: 20px;
		max-height: 150px;
		line-height: 1.5;
		text-align: left;
	}

	/* 图片提交按钮样式 */
	.submit-img {
		width: 30%;
		height: auto;
		cursor: pointer;
		transition: transform 0.3s;
		position: absolute;
		bottom: 1%;
	}

	.submit-img:hover {
		transform: scale(1.05);
	}

	.submit-img:active {
		transform: scale(0.95);
	}

	.tip {
		width: 100%;
		height: auto;
		margin-bottom: 5vw;
	}

	.bindCard {
		width: 100%;
		height: auto;
		margin-bottom: 8vw;
		cursor: pointer;

		/* 第一个bindCard的特殊样式 */
		&.first-bind-card {
			margin-bottom: 5vw;
		}

		/* 进度状态样式 */
		&.progress-state {
			cursor: default;
			position: relative;

			.progress-bg {
				position: relative;
				display: inline-block;
				width: 90%;

				.progress-bg-img {
					width: 100%;
					height: auto;
					display: block;
				}

				.progress-bar-img {
					position: absolute;
					bottom: 10%;
					right: 8%;
					width: 60%;
					height: auto;
					z-index: 1;
				}
			}
		}
	}

	.tip img,
	.bindCard img {
		width: 90%;
	}

	/* 绑定提示文字样式 */
	.bind-hint-text {
		width: 80%;
		padding: 10px;
		margin-top: 20px;
		margin-bottom: 15px;
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 1.4;
		border-radius: 10px;
		color: #fff;
		background-color: #ee0a24;
		position: absolute;
		bottom: 15%;
	}

	/* 信息修改/设置密码按钮样式 */
	.modify-btn {
		width: 40%;
		padding: 12px 20px;
		background-color: #ff4444;
		border: 2px solid #ffffff;
		border-radius: 25px;
		color: #ffffff;
		font-size: 16px;
		font-weight: bold;
		text-align: center;
		cursor: pointer;
		transition: all 0.3s ease;
		position: absolute;
		bottom: 5%;
		box-shadow: 0 4px 10px rgba(255, 68, 68, 0.3);

		&:hover {
			background-color: #ff3333;
			transform: translateY(-2px);
			box-shadow: 0 6px 15px rgba(255, 68, 68, 0.4);
		}

		&:active {
			background-color: #ff2222;
			transform: translateY(0);
			box-shadow: 0 2px 5px rgba(255, 68, 68, 0.3);
		}
	}

	.second-content {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		width: 100%;
		background-image: url('../../assets/withdrawBankCard/second_bg.png');
		background-size: cover;
		background-position: center;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #333;
		position: relative;
		overflow: auto;

		.first-line {
			width: 100%;
			padding: 15px 20px;
			background-image: url('../../assets/withdrawBankCard/second_top_bg.png');
			background-size: cover;
			background-position: center;
			min-height: 145px;
			display: flex;
			flex-direction: column;
			position: relative;

			.name {
				position: absolute;
				top: 15px;
				right: 20px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				text-align: right;
			}

			.icon {
				position: absolute;
				bottom: 15px;
				left: 0;
				right: 0;
				display: flex;
				justify-content: space-around;
				align-items: center;
				padding: 0 20px;

				.icon-content {
					flex: 1;
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 0 5px;

					.icon-image {
						width: 65px;
						height: 65px;
						object-fit: contain;
						cursor: pointer;
						transition: transform 0.3s;

						&:hover {
							transform: scale(1.1);
						}
					}
				}
			}
		}

		.second-line {
			width: 100%;
			padding: 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			background-color: #a31f1f;
			border-radius: 0 0 10px 10px;

			.icon-content {
				width: 23%;
				/* 4个一排，留一些间隙 */
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 15px;

				&:nth-child(n+5) {
					margin-bottom: 0;
					/* 第二行不需要底部边距 */
				}

				.icon-image {
					width: 55px;
					// height: 45px;
					object-fit: contain;
					cursor: pointer;
					transition: transform 0.3s;

					&:hover {
						transform: scale(1.1);
					}
				}
			}
		}

		.third-line {
			width: 100%;
			padding: 20px;
			background-color: rgba(255, 255, 255, 0.9);
			border-radius: 0 0 10px 10px;
			position: relative;

			.wealth-title {
				position: absolute;
				top: 20px;
				left: 20px;
				font-size: 16px;
				font-weight: bold;
				color: #333;
			}

			.balance-content {
				display: flex;
				justify-content: space-between;
				margin-top: 35px;

				.account-balance,
				.card-balance {
					flex: 0 0 48%;
					position: relative;
					height: 100px;
					border-radius: 8px;
					overflow: hidden;

					.balance-bg {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						object-fit: cover;
						z-index: 1;
						box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
					}

					.balance-text {
						position: relative;
						z-index: 2;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						align-items: baseline;
						padding: 10px;
						color: #000;
						font-weight: bold;
						// text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);

						.balance-label {
							font-size: 18px;
							margin-bottom: 5px;
						}

						.balance-value {
							font-size: 20px;
						}
					}
				}

				.account-balance {
					margin-right: 2%;
				}

				.card-balance {
					margin-left: 2%;
				}
			}
		}

		.fourth-line {
			width: 100%;
			padding: 20px 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 20px;
			margin-bottom: 20vw;

			img {
				max-width: 100%;
				margin-bottom: 10px;

				&:nth-child(2n) {
					cursor: pointer;
					transition: transform 0.3s;
					max-width: 50%;
					margin-top: 15px;

					&:hover {
						transform: scale(1.05);
					}
				}
			}
		}
	}
</style>